import { RemoteConfigVariables } from 'fitbeat.models';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { FirebaseRemoteConfig } from '../../utils/FirebaseRemoteConfig';
import { Logger } from '../../utils/Logger';

interface IProps {
  remoteConfigKey: RemoteConfigVariables;
  childPropConfiguredUsingRemoteConfig: (remoteConfigValue: string) => { [propName: string]: any };
  children: React.ReactChild;
}

export const RemoteConfigWrapper: FunctionComponent<IProps> = ({
                                                                 remoteConfigKey,
                                                                 childPropConfiguredUsingRemoteConfig,
                                                                 children,
                                                               }) => {
  const [text, setText] = useState(null);
  useEffect(() => {
    async function getRemoteText() {
      const textFromRemoteConfig = await FirebaseRemoteConfig.getRemoteConfigValue(
        remoteConfigKey,
      );
      setText(textFromRemoteConfig);
    }
    getRemoteText()
      .catch((e) => Logger.notify(e));
  }, []);

  const childrenWithConfiguredProp = React.isValidElement(children) && React.Children.only(children) ?
    React.cloneElement(children, { ...childPropConfiguredUsingRemoteConfig(text!) }) : <></>;

  if (text) {
    return childrenWithConfiguredProp;
  }
  return <></>;
};
